import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription }   from 'rxjs/Subscription';

import { AuthService } from '../../../../providers/auth.service';
import { SharedHackService } from '../../shared/services/shared-hack.service';
import { ScreenTalentService } from '../screen-talent.service';


export class TestComponent implements OnInit, OnDestroy {

	 public test: any;
	 public context: any;

	public state: any = {
		view: 'summary'
	};

	public eventsSubscription: Subscription;

	constructor(
		private authService: AuthService,
		private sharedHackService: SharedHackService,
		private screenTalentService: ScreenTalentService) { }

	// Lifecycle Events
	public ngOnInit(): void {
		this.eventsSubscription = this.screenTalentService.emitEventAction$.subscribe(
			(data) => {
				this.fetchEvent(data);
			}
		);
	}

	public ngOnDestroy(): void {
		if (this.eventsSubscription) {
			this.eventsSubscription.unsubscribe();
		}
	}

	// Events
	public onViewChange(view: string): void {
		this.state.view = view;
	}

	public onTestPropertyChange(changes: any) {
		let body: any = {};
		let propagateChanges: boolean = false;
		if (changes && changes.fingerprint && changes.hasOwnProperty('data')) {
			switch (changes.fingerprint) {
				case 'title':
					body['value'] = changes.data;
					propagateChanges = true;
					break;
				default:
					this.test[changes.fingerprint] = changes.data;
					break;
			}
			this.sharedHackService.patchExternalTest(String(this.authService.userId), this.test.id, changes.fingerprint, body).subscribe(
				(test) => {
					switch (changes.fingerprint) {
						case 'title':
							this.test.title = changes.data;
							propagateChanges = true;
							break;
						default:
							this.test[changes.fingerprint] = changes.data;
							break;
					}
				}
			);
		}
	}

	// Helpers
	private fetchEvent(event: any): void {
		if (event.component && event.component === 'test' && event.action) {
			switch (event.action) {
				case 'changeView':
					this.onViewChange(event.data);
					break;
				default:
					// code...
					break;
			}
		}
	}
static ctorParameters() { return [ { type: AuthService }, { type: SharedHackService }, { type: ScreenTalentService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/test/test.component.ts